__turbopack_context__.v({
  "root": "ContactDetails-module-scss-module__b5m9IG__root",
});
